import { WHATS_APP_URL } from 'config';

export * from '../utils/urls.js';

export const buildWhatsAppLink = (phone, message) => {
  let link = `${WHATS_APP_URL}/${phone}`;

  if (message) {
    link = `${link}?text=${encodeURIComponent(message)}`;
  }

  return link;
};
